/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { Collapse, Typography } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import ErrorRoundedIcon from '@material-ui/icons/ErrorRounded';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  alertError: {
    backgroundColor: theme.palette.error.background,
    alignItems: 'center',
    color: theme.palette.error.text,
    marginTop: '1.25rem',
    marginBottom: '1.25rem',
  },
}));

export default function FileError({ errorMsgs, onClose }) {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Collapse in={errorMsgs?.length > 0}>
      <Alert
        severity="error"
        variant="outlined"
        onClose={() => {
          onClose();
        }}
        className={classes.alertError}
        icon={<ErrorRoundedIcon />}
      >
        {errorMsgs?.map((msg, index) => (
          <Typography key={index}>
            <strong>{`${t('Error')}: `}</strong>
            {t(msg)}
          </Typography>
        ))}
      </Alert>
    </Collapse>
  );
}
